import { takeLatest, put, call } from 'redux-saga/effects';

import { findVendaAnimal } from '../service';
import {
  FIND_VENDA_ANIMAL,
  FIND_VENDA_ANIMAL_PENDING,
  FIND_VENDA_ANIMAL_SUCCESS,
  FIND_VENDA_ANIMAL_FAILURE
} from '../actionTypes';

function* sagaFindVendaAnimal(action) {
  yield put({ type: FIND_VENDA_ANIMAL_PENDING, id: action.id })

  try {

    const registro = yield call(findVendaAnimal, action.id);

    yield put({ type: FIND_VENDA_ANIMAL_SUCCESS, registro: registro })

  } catch (error) {

    yield put({ type: FIND_VENDA_ANIMAL_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchFindVendaAnimal() {
  yield takeLatest(FIND_VENDA_ANIMAL, sagaFindVendaAnimal)
}
